import { getAPIDomain } from '../../helpers/configHelpers';
import { logger } from '../../helpers/logger';
import { eventToDataLayer, formStepStrings } from '../../helpers/trackerHelpers';

export const UPDATE_ACTIVE_FORM = 'UPDATE_ACTIVE_FORM';
export const UPDATE_ACTIVE_STEP = 'UPDATE_ACTIVE_STEP';
export const FETCH_FORM_DATA_START = 'FETCH_FORM_DATA_START';
export const FETCH_FORM_DATA_END = 'FETCH_FORM_DATA_END';
export const FETCH_FORM_DATA_ERROR = 'FETCH_FORM_DATA_ERROR';

const activeForm = {
  ArrangeMeeting: 'arrange-meeting',
  MakeEnquiry: 'make-enquiry',
  RequestCallback: 'request-callback',
  FeedbackForm: 'feedback-form',
  StaffEnquiryForm: 'staff-enquiry-form',
};

export const updateActiveForm = (formId) => (dispatch) => {
  dispatch({
    type: UPDATE_ACTIVE_FORM,
    payload: {
      formId,
    },
  });
};

export const updateActiveStep = (step) => (dispatch, getState) => {
  // Update data layer with active form and active step
  const activeFormId = getState().formWizard.id;
  const activeFormSlug = activeForm[activeFormId];

  if (activeFormSlug && step && window && window.dataLayer) {
    window.dataLayer.push({
      event: 'pageView',
      pagePath: `/contact/${activeFormSlug}/step${step}`,
    });
  }

  if (formStepStrings[step]) {
    eventToDataLayer('form_view', { form_step: formStepStrings[step] });
  }

  // Dispatch update form step
  dispatch({
    type: UPDATE_ACTIVE_STEP,
    payload: {
      step,
    },
  });
};

export const fetchFormData = (slug, data) => async (dispatch, getState) => {
  let formData = null;
  let queryString = '';
  if (data) {
    queryString = `?${Object.keys(data)
      .map(function (key) {
        return `${key}=${encodeURIComponent(data[key])}`;
      })
      .join('&')}`;
  }

  const contentAPIDomain = getAPIDomain();

  try {
    dispatch({ type: FETCH_FORM_DATA_START });

    if (!data?.partner) {
      const partner = getState().page?.pageData?.context?.content?.partner;

      if (queryString && partner) {
        queryString += `&partner=${partner}`;
      } else {
        queryString = `?partner=${partner}`;
      }
    }

    const headers = {
      Authorization: 'Basic U0pQOlBhcnRuZXI=',
      'Content-Type': 'application/json',
    };

    const res = await fetch(contentAPIDomain + slug + queryString, {
      method: 'GET',
      headers,
    });
    if (!res.ok) {
      throw Error(res.statusText);
    }
    formData = await res.json();
  } catch (error) {
    logger.error(`Error getting form data for the URL : ${contentAPIDomain}${slug}`);
    dispatch({ type: FETCH_FORM_DATA_ERROR });
  }

  const getActiveForm = getState().formWizard.id;

  if (
    formData &&
    formData.subject.regions
      .find((element) => element.id === 'MainRegion')
      .fragments.find((element) => element.template.id === getActiveForm)
  ) {
    dispatch({
      type: FETCH_FORM_DATA_END,
      payload: formData.subject.regions
        .find((element) => element.id === 'MainRegion')
        .fragments.find((element) => element.template.id === getActiveForm).content,
    });
  }
};
